import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.transitions,"label":_vm.t('Order state'),"loading":_vm.loading,"outlined":""},on:{"input":_vm.transitionHandler},model:{value:(_vm.transition),callback:function ($$v) {_vm.transition=$$v},expression:"transition"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }